"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ ACCORDION > STYLE ] ##################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var AccordionContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionContainer",
  componentId: "yik5n7-0"
})(["display:grid;grid-template-columns:1fr 1fr;grid-gap:var(--gutter-medium);list-style:none;margin:0;padding:0;text-align:left;width:100%;flex:none;", " @media ", "{grid-template-columns:1fr;grid-gap:var(--gutter);};@media ", "{grid-template-columns:1fr;grid-gap:var(--gutter);};"], function (_ref) {
  var hasBorder = _ref.hasBorder;
  return hasBorder ? 'padding: var(--gutter-small); border: solid 1px var(--color); border-radius: var(--radius-small)' : null;
}, _architectMixins._mixin_device.s, _architectMixins._mixin_device.m); // 3.1. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.AccordionContainer = AccordionContainer;